import { render, staticRenderFns } from "./FormInventory.vue?vue&type=template&id=23632050"
import script from "./FormInventory.vue?vue&type=script&lang=js"
export * from "./FormInventory.vue?vue&type=script&lang=js"
import style0 from "./FormInventory.vue?vue&type=style&index=0&id=23632050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports